import React, { useEffect } from 'react';
import cn from 'classnames';
import classNames from 'classnames';
import type { Criteria } from 'types';

import { useAppDispatch, useAppSelector } from 'hooks/useRedux';
import Logo from 'layouts/header/Logo';
import { logActivity } from 'services';
import { trackUserPageViewActivities } from 'services/userService';
import { updateAnonymousUser } from 'store/user/actions';
import { logEventGTM } from 'utils/analyticsGTM';

import headerCss from '../index.module.css';
import classes from './headerWithPB.module.css';

const HeaderWithProgressBar: React.FC<{
  criteria: Criteria;
  stickyHeader?: boolean;
}> = ({ criteria, stickyHeader }) => {
  const dispatch = useAppDispatch();

  const progress = useAppSelector((state) => state.extra.headerProgressBarProgress);

  useEffect(() => {
    const logPayload = {
      pageCategory: window.pageCategory,
    };

    logActivity(logPayload)
      .then((userResponse) => {
        const user = userResponse?.data?.user;
        dispatch(updateAnonymousUser(user));

        if (!window.userId) {
          window.userId = user.userId;
        }
        window.isLoggedIn = user.isLoggedIn || false;

        logEventGTM();
      })
      .catch(() => {
        console.error('Error ocurred while logging activity inside the Header.');
      })
      .finally(() => {
        if (criteria) {
          trackUserPageViewActivities(criteria);
        }
      });
  }, [criteria, dispatch]);

  return (
    <nav className={cn('navbar p-0', headerCss.navbar, {[classes.stickyHeader]: stickyHeader })}>
      <div className={cn('container d-flex flex-nowrap gg-16', headerCss.container)}>
        <Logo noLinks userLoggedIn={false} showSmallLogo={false} containerClassName="d-none d-md-block" />

        <div className="d-flex flex-column flex-md-row justify-content-end align-items-center w-100">
          <div className={cn('z-mr-12 z-my-12 z-my-md-0', classes.title)}>Your Progress</div>
          <div className={classes.container}>
            <div className={classes.bar} style={{ width: `${progress}%` }} />
            <div
              className={classes.tick}
              style={{
                left: progress > 94 ? `calc(${progress}% - 24px)` : `${progress}%`,
              }}
            >
              <div className={classes.circle}>
                <div className={classNames('icon-icn-checkbtn', classes.tickImage)} />
              </div>
            </div>
          </div>
          {progress < 100 && (
            <div className={classes.star}>
              <div className={classNames(classes.circle, classes.green)}>
                <div className={classNames('icon-icn-matches', classes.starImage)} />
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default HeaderWithProgressBar;
